export class LuceneQueryInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LuceneQueryInput.attributeTypeMap;
    }
    constructor() {
    }
}
